const mfaEnterCodeTemplate = `<pwr-mfa linking-context="linkingContext"></pwr-mfa>`;
export default mfaEnterCodeTemplate;
